import { Button, SwitchIcon } from '@bp/ui-components';
import classNames from 'classnames';
import { useAuthClaims } from 'hooks/useAuthClaims';
import { usePermissionChecker } from 'hooks/usePermissionChecker';
import { useTranslation } from 'react-i18next';
import styles from './ChildrenOverview.module.scss';

type ChildrenOverviewProps = {
  hideImpersonate?: boolean;
  onProfileSwitch?: (uuid: string) => void;
  className?: string | undefined;
};

export const ChildrenOverview = ({ hideImpersonate, onProfileSwitch, className }: ChildrenOverviewProps) => {
  const { t } = useTranslation();
  const { pimAuthClaims } = useAuthClaims();
  const childProfilesClaim = pimAuthClaims.getChildProfiles();

  const permissions = usePermissionChecker();

  const children = hideImpersonate ? childProfilesClaim.filter((c) => !c.canBeImpersonated) : childProfilesClaim;

  return (
    <div className={classNames(styles['children-overview'], className)}>
      {children.map((c) => {
        return (
          <div key={c.uuid} className={styles.child}>
            <div className={styles.name}>{c.displayName}</div>
            {onProfileSwitch && c.canBeImpersonated && permissions?.canImpersonateChildProfile() && (
              <Button
                hierarchy='secondary'
                height='s'
                icon={<SwitchIcon className='small' />}
                onClick={() => onProfileSwitch(c.uuid)}
                className={styles.button}
              >
                {t('children.impersonateProfile')}
              </Button>
            )}
          </div>
        );
      })}
    </div>
  );
};
